import React from 'react';
import { withStyles } from '@material-ui/core';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import styles from './PaymentMethodSelectorStyles';
import { PAYMENT_METHOD_LABEL } from '../../constants/types';
import MercadoPagoPaymentMethod from './PaymentMethodLabel/mercadopagoPaymentMethod';
import ModoPaymentMethod from './PaymentMethodLabel/modoPaymentMethod';
import CardPaymentMethod from './PaymentMethodLabel/cardPaymentMethod';

const PaymentMethodSelector = ({ classes, paymentMethods, onChange, value }) => {
  const getPaymentMethodLabel = (paymentOption) => {
    const { label } = paymentOption;

    switch (label) {
      case PAYMENT_METHOD_LABEL.MERCADOPAGO:
        return <MercadoPagoPaymentMethod paymentOption={paymentOption} />;
      case PAYMENT_METHOD_LABEL.CARD:
        return <CardPaymentMethod paymentOption={paymentOption} />;
      case PAYMENT_METHOD_LABEL.MODO:
        return <ModoPaymentMethod paymentOption={paymentOption} />;

      default:
        return <CardPaymentMethod paymentOption={paymentOption} />;
    }
  };

  const handlePaymentChange = ({ target }) => {
    onChange(target.value);
  };

  return (
    <Box className={classes.paymentMethodSelectorContainer}>
      <RadioGroup value={value} onChange={handlePaymentChange}>
        {paymentMethods.map((paymentOption, index) => (
          <FormControlLabel
            labelPlacement="start"
            key={`${paymentOption.method}-${index}`}
            value={index}
            control={<Radio />}
            label={getPaymentMethodLabel(paymentOption)}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default withStyles(styles)(PaymentMethodSelector);
